import { Box, Text } from "@nulogy/components";
import React from "react";

export default function NoResultsFound() {
  return (
    <Box marginTop="96px">
      <Text color="black" fontSize="medium" fontWeight="bold" marginBottom="x1" textAlign="center">
        No results found
      </Text>
      <Text color="black" fontSize="small" textAlign="center">
        Please refine search term or filters
      </Text>
    </Box>
  );
}
